import {
  GetCancelacionesProceso,
  GetCancelacionesIntentos,
  PostVerificarCancelacion,
  PostConfirmarCancelacion,
  PostReenviarSolicitudCancelacion
} from "../../reducers/notaCredito";

export interface CancelacionesProcesoStore
  extends GetCancelacionesProceso,
    GetCancelacionesIntentos,
    PostVerificarCancelacion,
    PostConfirmarCancelacion,
    PostReenviarSolicitudCancelacion {}

export const cancelacionesProcesoStore: (
  state
) => CancelacionesProcesoStore = state => {
  const notasCredito = state.notasCredito;

  return {
    cancelacionesProceso: notasCredito.cancelacionesProceso,
    gettingCancelacionesProceso: notasCredito.gettingCancelacionesProceso,
    gettingCancelacionesProcesoError:
      notasCredito.gettingCancelacionesProcesoError,

    cancelacionesIntentos: notasCredito.cancelacionesIntentos,
    gettingCancelacionesIntentos: notasCredito.gettingCancelacionesIntentos,
    gettingCancelacionesIntentosError:
      notasCredito.gettingCancelacionesIntentosError,

    postingVerificarCancelacion: notasCredito.postingVerificarCancelacion,
    postingVerificarCancelacionError:
      notasCredito.postingVerificarCancelacionError,

    postingConfirmarCancelacion: notasCredito.postingConfirmarCancelacion,
    postingConfirmarCancelacionError:
      notasCredito.postingConfirmarCancelacionError,

    postingReenviarSolicitudCancelacion:
      notasCredito.postingReenviarSolicitudCancelacion,
    postingReenviarSolicitudCancelacionError:
      notasCredito.postingReenviarSolicitudCancelacionError
  };
};
